/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { ShipmentAddress } from './shipment-addresses.models';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Shipment } from '@qwyk/shared-stores/shipments';

export const init = createAction(
    '[Portals/Shipments/Addresses] Init',
    props<{ shipment: Shipment }>()
);

export const loadShipmentAddressesSuccess = createAction(
    '[Portals/Shipments/Addresses] Load ShipmentAddresses Success',
    props<{ shipmentAddresses: ShipmentAddress[] }>()
);

export const loadShipmentAddressesFailure = createAction(
    '[Portals/Shipments/Addresses] Load ShipmentAddresses Failure',
    props<{ error: any }>()
);

export const updateShipmentAddress = createAction(
    '[Portals/Shipments/Addresses] Update ShipmentAddress',
    props<{ shipment: Shipment; shipmentAddress: ShipmentAddress }>()
);

export const updateShipmentAddressesSuccess = createAction(
    '[Portals/Shipments/Addresses] Update ShipmentAddresses Success',
    props<{ shipmentAddress: ShipmentAddress }>()
);

export const updateShipmentAddressesFailure = createAction(
    '[Portals/Shipments/Addresses] Update ShipmentAddresses Failure',
    props<{ error: any }>()
);

export const selectShipmentAddress = createAction(
    '[Portals/Shipments/Addresses] Select ShipmentAddress',
    props<{ shipmentAddress: ShipmentAddress }>()
);

export const unselectShipmentAddress = createAction(
    '[Portals/Shipments/Addresses] Unselect ShipmentAddress'
);

export const reset = createAction('[Portals/Shipments/Addresses] Reset');
